export default __webpack_public_path__ + "static/media/service-license-flow2.7055d8dc.png";